import { combineReducers } from 'redux';

import filterBarReducer from './ducks/filterBar';
import filtersReducer from './ducks/filters';
import flatBuildsReducer from './ducks/flatBuilds';
import flatJobsReducer from './ducks/flatJobs';
import flatHeadlessJobsReducer from './ducks/flatHeadlessJobs';
import flatManualReducer from './ducks/flatManual';
import usersReducer from './ducks/users';

const reducers = {
  filterBar: filterBarReducer,
  filters: filtersReducer,
  flatBuilds: flatBuildsReducer,
  flatManual: flatManualReducer,
  flatJobs: flatJobsReducer,
  flatHeadlessJobs: flatHeadlessJobsReducer,
  users: usersReducer,
};

export default combineReducers(reducers);
